<div class="fullwidthimage"
  [style.background-image]="'url(' + image + ')'"
  (click)="click()"
  fxLayout="row"
  fxLayoutAlign="center center">

  <button *ngIf="!userService.isLoggedIn"
    class="orange-button">{{buttontext}}</button>

</div>